import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { requestPasswordReset, authErrorMessage } from '../../../../shared/services/authService';
import ColourTextLogo from '../../../../colour_text_logo.svg';
import MakerspaceDarkLogo from '../../../../makerspace_dark_logo.png';
import './LoginScreen.css';

const ForgotPasswordScreen = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const normalizedEmail = email.toLowerCase().trim();
      await requestPasswordReset(normalizedEmail);
      setSuccess(true);
    } catch (err) {
      console.error('Forgot password error:', err);
      // Don't reveal whether the account exists.
      if (err?.code === 'auth/user-not-found') {
        setSuccess(true);
      } else {
        setError(authErrorMessage(err, 'An error occurred. Please try again.'));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-container">
        <div className="login-gradient-header"></div>
        <div className="login-card-content">
          <div className="login-logos">
            <img src={ColourTextLogo} alt="Framework" className="login-logo" />
            <span className="login-logo-divider">|</span>
            <img src={MakerspaceDarkLogo} alt="MakerSpace" className="login-logo login-logo-makerspace" />
          </div>
          <h1 className="login-title">Reset Password</h1>
          <p className="login-subtitle">
            Enter your email address and we'll send you a link to reset your password
          </p>

          {error && (
            <div className="login-error" role="alert">
              {error}
            </div>
          )}

          {success && (
            <div className="login-success" role="alert">
              If an account exists with this email, a password reset link has been sent. Please check your inbox.
            </div>
          )}

          {!success && (
            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                  autoComplete="email"
                  disabled={loading}
                />
              </div>

              <button
                type="submit"
                className="login-button"
                disabled={loading || !email}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          )}

          <div className="login-footer">
            <button
              type="button"
              className="toggle-mode-button"
              onClick={() => navigate('/login')}
              disabled={loading}
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordScreen;

